// render dialog that slides in from the right side, full page height
//
// SideDialog.render('foo')
// SideDialog.render('foo', { width: 300})
// SideDialog.close()
// <ui-side-dialog width="600">foo</ui-side-dialog>
// <div data-controller="side-dialog" width="600">foo</div>

class SideDialog {
  static prepare() {
    if (!$('#side-dialog')[0]) {
      $(document.body).append(`
        <div id="side-dialog">
          <style>
            .side-dialog-overlay { z-index: 1; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(100, 100, 100, 0.3); }
            .side-dialog-main { overflow-y: auto; z-index: 2; position: fixed; width: 500px; height: 100vh; top: 0; right: 0; background-color: #fff; border-left: 1px solid #ccc; padding: 15px; transform: translateX(100%); transition: transform 0.5s ease-in-out; }
            .side-dialog-main.show { transform: translateX(0); }
            .side-dialog-close { float: right; font-size: 30px; color: #777; margin-top: -15px; }
          </style>
          <div class="side-dialog-overlay" onclick="SideDialog.close()"></div>
          <div class="side-dialog-main">
            <span
              class="side-dialog-close"
              data-key="Escape"
              title="You can close this dialog with Escape key"
              aria-label="Close"
              onclick="SideDialog.close()"
            >&times;</span>
            <div class="side-dialog-body"></div>
          </div>
        </div>
      `)
    }
  }

  static close() {
    $('#side-dialog').remove()
  }

  // base method that creates side dialog
  static render(html, opts = {}) {
    this.close()
    this.prepare()
    $('.side-dialog-body').html(html)

    setTimeout(()=>{
      const node = $('.side-dialog-main')
      node.addClass('show')
      // node.css('width', `${opts.width || 500}px`)

      // links with class page-link will be loaded inside side-dialog
      $('.offcanvas a.page-link').each((_, n)=>{
        n.setAttribute("onclick", "SideDialog.load(this.getAttribute('href')); return false")
      })
    }, 50)
  }

  // load frame data via url
  static load(path, opts) {
    SideDialog.lastPath = path
    $.get(path, data => this.render(data, opts))
  }

  static isOpen() {
    return !!$('#side-dialog')[0]
  }

  static reload() {
    SideDialog.load(SideDialog.lastPath)
  }

  // if initialized via Stimulus controller, just get attrs and call base method
  connect() {
    const html = this.element.innerHTML
    this.element.innerHTML = ''
    SideDialogController.render(html)
  }
}

// BaseController.register('side-dialog')

// allows -> SideDialog.load(path)
window.SideDialog = SideDialog
